$(document).ready(function() {
    $('#homepage-arrow').click(function(e)   {
        ga('send', 'event', 'Home', 'Arrow', 'We Are Communicraft');
    });
    $('#about-arrow').click(function(e)   {
        ga('send', 'event', 'About', 'Arrow', 'Why Work With Us');
    });
    $('#service-arrow').click(function(e)   {
        ga('send', 'event', 'Services', 'Arrow', 'We Do More');
    });

    function isElementInViewport (el) {
        if (typeof jQuery === "function" && el instanceof jQuery) {
            el = el[0];
        }
        var rect = el.getBoundingClientRect();
        return (
            rect.top >= 0 &&
                rect.left >= 0 &&
                    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
                    rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
        );
    }

    function onVisibilityChange(el, callback) {
        if(el.length !== 1)
            return;
        var old_visible;
        return function () {
            var visible = isElementInViewport(el);
            if (visible != old_visible) {
                old_visible = visible;
                if (typeof callback == 'function') {
                    callback(el, visible);
                }
            }
        };
    }

    $('.js-ga-tracker').each(function(i, el)    {
        var a = onVisibilityChange($(el), function(el, visible) {
            if(!el.fired && visible)   {
                el.fired = true;
                var category = $(el).data('tracker-event-category');
                var label = $(el).data('tracker-event-label');
                if(category !== undefined && label !== undefined)   {
                    ga('send', 'event', category, 'Scroll Point', label);
                }
            }
        });
        $(window).on('DOMContentLoaded load resize scroll', a); 
    });
});
